  // Función para obtener el porcentaje de IVA según el valor seleccionado
  export const getPorcentajeIVA = (value) => {
    switch (value) {
      case "1":
        return 0.21; // 21%
      case "2":
        return 0.105; // 10.5%
      case "3":
        return 0; // 0%
      default:
        return 0;
    }
  };